// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__WRX1g","light":"divider_light__aQkcx","dark":"divider_dark__vsnuF"};